import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MaterialTable from 'material-table';
import AskAlert from '../common/AskAlert';
import{ SERVER_PATH, AXIOS_CONFIG , ROLE_VIEWER,STATUS_PROJECT_PUBLISHED} from '../common/redux/constantes';
// import moment from 'moment';
import DownloadCsv from "../common/DownloadCsv"


class ListActualCosts extends Component {
  static propTypes = {
    actual: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state ={
    actual_costs:[],
    openDeleteAlert:false,
    deleteActualCostID:-1
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.setDownloadInfo=this.setDownloadInfo.bind(this)
  }

  deleteActualcost =()=>{
    if(this.state.deleteActualCostID !== -1){
      this.props.actions.deleteActualCost(this.tableRef,this.state.deleteActualCostID,this.props.project);
      this.setState({openDeleteAlert:false});
    }
  }


  cancelDelete = () =>{
    this.setState({openDeleteAlert:false});
  }

  askDeleteActualCost= (actualCostID)=>{
    this.setState({openDeleteAlert:true, deleteActualCostID:actualCostID});
  }  

  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }


  setDownloadInfo=(info)=>
  {
    let value={ data:JSON.parse(JSON.stringify(info)), 
             headers:[
             {label:"Invoice Date", key:"invoice_date"},
             {label:"Record Date", key:"record_date"},
             {label:"Reporting Period", key:"reporting_number"},
             {label:"Control Account", key:"ca_name"},
             {label:"Total Cost", key:"total_cost"},
             {label:"Inv. Number", key:"inv_number"},
             {label:"Company", key:"company"},
             ],
             tableName:"ActualCosts", 
             type:6
           }
     this.setState({
       tableData:value
     })
   }

  render() {

      let actionButtons =[
        {
          icon: 'delete',
          tooltip: 'Delete',
          onClick: (event, rowData) => this.askDeleteActualCost(rowData.actual_cost) 
        },{
          icon: 'edit',
          tooltip: 'Edit',
          onClick: (event, rowData) => this.props.editActualCost(rowData)
        },
        {
          icon: 'visibility',
          tooltip: 'View information',
          onClick: (event, rowData) => this.props.showActualCost(rowData) 
        },
        {
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange()
        },
        {
          icon: 'save',
          tooltip: 'Save Data',
          isFreeAction: true,
          onClick: () => 
          {
            this.childref.downloadData()
          }
        }
      ];
      //Verificamos permisos
      if(Number(localStorage.getItem("role"))===ROLE_VIEWER || this.props.project_status!==STATUS_PROJECT_PUBLISHED)
      {
        actionButtons.splice(0,2);
      }
      return (
        <div style={{backgroundColor:"yellow"}}>
          <MaterialTable
          tableRef={this.tableRef}
          
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          
          options={{
            actionsColumnIndex:10,
            paging:false,
            search:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#fff',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: (rowData) => {
                return {
                backgroundColor: 
                    (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                    '#EEE' 
                    :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                }
            }
          }}
          title="Actual Costs"
          columns={[
            { 
              title: 'Invoice Date', 
              field: 'invoice_date',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              }, 
            },
            { 
              title: 'Record Date', 
              field: 'record_date',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              },
            },
            { 
              title: 'Reporting Period', 
              field: 'reporting_number',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              }, 
            },
            { 
              title: 'Control Account', 
              field: 'ca_name',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              }, 
            },
            { 
              title: 'Total Cost', 
              field: 'formatted_total_cost',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              },
            },
            { 
              title: 'Inv. Number', 
              field: 'inv_number',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              },
            },
            { 
              title: 'Company', 
              field: 'company',
              cellStyle: {
                  borderRight: "1px solid #d4d4d4"
              },
            },
          ]}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/actual_costs/byProject/' + this.props.project
            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {
                let formatter = null;
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    formatter = new Intl.NumberFormat('gt-GT', {
                      minimumFractionDigits: 2,
                    });
                  }
                result.actual_costs = result.actual_costs.map(o => {
                  if(o.invoice_date && o.record_date)
                  {
                    // o.invoice_date= moment(o.invoice_date).format('YYYY-MM-DD')
                    // o.record_date = moment(o.record_date).format('YYYY-MM-DD')
                  }
                  
                  if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    o.formatted_total_cost = formatter.format(o.total_cost);
                  }
                  return o;
                });
                this.setDownloadInfo(result.actual_costs)
                
                resolve({
                  data: result.actual_costs,
                  page: 0,
                  totalCount: result.actual_costs.length,
                })
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }

          actions={actionButtons}
        />

        <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref = node}
            tableData={this.state.tableData}
            ocultar={true}
        />
        <AskAlert openAlert={this.state.openDeleteAlert} handleCloseCancel={this.cancelDelete} handleCloseOk={this.deleteActualcost}
          dialogTitle="Delete Cost" dialogContent="Are you sure to delete this cost?" />
        </div>
      )
    }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    actual: state.actual,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ListActualCosts);



// WEBPACK FOOTER //
// ./src/features/actual/ListActualCosts.js